import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
// import Link from "@mui/material/Link";

function BreadFuncionario() {
  return (
    <Breadcrumbs
      separator="›"
      aria-label="breadcrumb"
      style={{ marginBottom: '10px', marginTop: '5px' }}
    >
      <Link to="/app" color="textPrimary">
        Inicio
      </Link>
      <Link to="/app/administracao/funcionarios" color="textPrimary">
        Lista de Fucionários
      </Link>
      <Typography color="textPrimary">Funcionário</Typography>
    </Breadcrumbs>
  );
}
export default BreadFuncionario;
